var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Create Staging Environment ")]),
              _c(
                "gg-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.availableInstallations.clearList,
                      loading: _vm.loadingInstallations
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.softurl",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: item.softurl,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(item.softurl))]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  bottom: "",
                                  left: "",
                                  "offset-x": "",
                                  "min-width": "180"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function fn(_ref3) {
                                        var on = _ref3.on,
                                          attrs = _ref3.attrs
                                        return [
                                          _c(
                                            "gg-btn",
                                            _vm._g(
                                              _vm._b(
                                                {},
                                                "gg-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(" Manage "),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "ml-1"
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.openStageModal(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(" Create Staging ")
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.openRemoveModal(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(" Remove ")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Manage Staging Environment ")]),
              _c(
                "gg-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.stagingHeaders,
                      items: _vm.availableInstallations.stagingList,
                      loading: _vm.loadingInstallations
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.softurl",
                        fn: function fn(_ref4) {
                          var item = _ref4.item
                          return [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: item.softurl,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(item.softurl))]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref5) {
                          var item = _ref5.item
                          return [
                            _c(
                              "gg-btn",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  secondary: "",
                                  disabled: _vm.loadingPtl,
                                  loading:
                                    _vm.loadingPtl &&
                                    item.insid === _vm.selectedService.insid
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.goLive(item)
                                  }
                                }
                              },
                              [_vm._v(" Push To Live ")]
                            ),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  bottom: "",
                                  left: "",
                                  "offset-x": "",
                                  "min-width": "180"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function fn(_ref6) {
                                        var on = _ref6.on,
                                          attrs = _ref6.attrs
                                        return [
                                          _c(
                                            "gg-btn",
                                            _vm._g(
                                              _vm._b(
                                                {},
                                                "gg-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(" Manage "),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "ml-1"
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        attrs: {
                                          disabled: _vm.loadingLogin
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.login(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          [
                                            _vm._v(" WP Dashboard "),
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mb-1 ml-1",
                                                attrs: {
                                                  small: ""
                                                }
                                              },
                                              [_vm._v("mdi-open-in-new")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        on: {
                                          click: function click($event) {
                                            return _vm.openRemoveModal(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(" Remove ")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.removeModal
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.removeModal
            },
            on: {
              close: _vm.closeRemoveModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Remove Installation ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Remove Directory",
                                  "true-value": "on",
                                  "false-value": "off"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                "max-width": "300"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref7) {
                                                      var on = _ref7.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " mdi-help-circle-outline "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                73716224
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " If you check this the entire folder will be deleted "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3727321048
                                ),
                                model: {
                                  value: _vm.removeModel.remove_dir,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.removeModel, "remove_dir", $$v)
                                  },
                                  expression: "removeModel.remove_dir"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Remove Database",
                                  "true-value": "on",
                                  "false-value": "off"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                "max-width": "300"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref8) {
                                                      var on = _ref8.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " mdi-help-circle-outline "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                73716224
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " If checked the database will be deleted "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3971504846
                                ),
                                model: {
                                  value: _vm.removeModel.remove_db,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.removeModel, "remove_db", $$v)
                                  },
                                  expression: "removeModel.remove_db"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: "Remove Database User",
                                  "true-value": "on",
                                  "false-value": "off"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                "max-width": "300"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref9) {
                                                      var on = _ref9.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " mdi-help-circle-outline "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                73716224
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " If checked the database user will also be deleted "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1056887438
                                ),
                                model: {
                                  value: _vm.removeModel.remove_dbuser,
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.removeModel,
                                      "remove_dbuser",
                                      $$v
                                    )
                                  },
                                  expression: "removeModel.remove_dbuser"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.closeRemoveModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            loading: _vm.loadingRemove,
                            disabled: _vm.loadingRemove
                          },
                          on: {
                            click: _vm.removeInstallation
                          }
                        },
                        [_vm._v("Remove")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1301943723
            )
          })
        : _vm._e(),
      _vm.ptlModal
        ? _c("go-live-modal", {
            attrs: {
              options: _vm.pushToLiveOptions,
              service: _vm.selectedService,
              "is-active": _vm.ptlModal
            },
            on: {
              update: _vm.getInstallations,
              close: _vm.closePtlModal
            }
          })
        : _vm._e(),
      _vm.stageModal
        ? _c("create-staging-modal", {
            attrs: {
              services: _vm.availableInstallations.clearList,
              service: _vm.selectedService,
              "is-active": _vm.stageModal
            },
            on: {
              close: _vm.closeStageModal
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }